module.exports = __webpack_public_path__ + "static/media/icon2.fbdbf1e0.png";